import { Directive, HostBinding, Input } from "@angular/core";

@Directive({
    selector: "hex-checkbox,hex-radio",
})
export class CustomHexChoiceFieldDirective {
    @Input()
    @HostBinding("style.background-color")
    public backgroundColor = "#FFFFFF";
}
